class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');

    this.addEventListener('mouseenter', this.openOnDesktop.bind(this));
    this.addEventListener('mouseleave', this.closeOnDesktop.bind(this));
    this.addEventListener('focusin', this.openOnDesktop.bind(this));
    this.addEventListener('focusout', this.closeOnDesktopFocusOut.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  openOnDesktop() {
    if (!this.desktopMediaQuery.matches) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  closeOnDesktop() {
    if (!this.desktopMediaQuery.matches) return;
    this.close();
  }

  closeOnDesktopFocusOut() {
    if (!this.desktopMediaQuery.matches) return;

    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
}

customElements.define('header-menu', HeaderMenu);
